import React from 'react';
import './terms.scss';

const TermsWrapper: React.FC = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>תנאי שימוש</h1>
        <p className="terms-updated">עודכן לאחרונה: {new Date().toLocaleDateString('he-IL')}</p>

        <section className="terms-section">
          <h2>1. הסכמה לתנאים</h2>
          <p>
            בעצם השימוש בשירותי FB Zipper (להלן: "השירות", "המערכת" או "הבוט"), הנך מאשר כי קראת,
            הבנת והסכמת לתנאי שימוש אלה במלואם. אם אינך מסכים לתנאים אלה, אנא הימנע משימוש בשירות.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. תיאור השירות</h2>
          <p>
            FB Zipper הוא כלי אוטומציה המאפשר פרסום תוכן בקבוצות פייסבוק. השירות מספק ממשק
            לניהול קמפיינים, תזמון פוסטים וניהול תוכן.
          </p>
        </section>

        <section className="terms-section important">
          <h2>3. אחריות המשתמש</h2>
          <p>
            <strong>השימוש בשירות הינו על אחריותו הבלעדית והמלאה של המשתמש.</strong>
          </p>
          <p>המשתמש מצהיר ומתחייב כי:</p>
          <ul>
            <li>הוא האחראי הבלעדי לכל תוכן שמפורסם באמצעות השירות</li>
            <li>הוא מחזיק בכל הזכויות הנדרשות לפרסום התוכן</li>
            <li>התוכן המפורסם אינו מפר זכויות יוצרים, סימני מסחר או קניין רוחני אחר</li>
            <li>התוכן אינו מכיל חומר פוגעני, מטעה, בלתי חוקי או מזיק</li>
            <li>השימוש בשירות נעשה בהתאם לתנאי השימוש של פייסבוק ומטא</li>
            <li>הוא נושא באחריות מלאה לכל תוצאה הנובעת משימוש בשירות</li>
          </ul>
        </section>

        <section className="terms-section important">
          <h2>4. הגבלת אחריות</h2>
          <p>
            <strong>FB Zipper, מפעיליו, עובדיו ושותפיו אינם אחראים בשום צורה לכל נזק, הפסד,
            תביעה או עלות הנובעים משימוש בשירות, לרבות אך לא רק:</strong>
          </p>
          <ul>
            <li>חסימה או השעיה של חשבון הפייסבוק של המשתמש</li>
            <li>הסרת תוכן או קבוצות על ידי פייסבוק</li>
            <li>תביעות משפטיות מצד שלישי בגין תוכן שפורסם</li>
            <li>הפרת תנאי השימוש של פייסבוק או מטא</li>
            <li>כל נזק ישיר, עקיף, תוצאתי או מיוחד</li>
            <li>אובדן הכנסות, רווחים או מוניטין</li>
          </ul>
          <p>
            המשתמש מוותר בזאת על כל טענה, דרישה או תביעה כלפי FB Zipper בקשר לשימוש בשירות.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. ציות לחוקים ותקנות</h2>
          <p>
            המשתמש מתחייב לציית לכל החוקים, התקנות והכללים החלים, לרבות:
          </p>
          <ul>
            <li>תנאי השימוש של פייסבוק ומטא</li>
            <li>חוקי הגנת הפרטיות והגנת המידע</li>
            <li>חוקי הגנת הצרכן ואיסור ספאם</li>
            <li>חוקי זכויות יוצרים וקניין רוחני</li>
            <li>כל חוק מקומי או בינלאומי רלוונטי אחר</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>6. שינויים בשירות ובתנאים</h2>
          <p>
            FB Zipper שומרת לעצמה את הזכות לשנות, להשעות או להפסיק את השירות או חלקים ממנו
            בכל עת וללא הודעה מוקדמת. כמו כן, אנו רשאים לעדכן תנאי שימוש אלה מעת לעת.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. סיום השימוש</h2>
          <p>
            FB Zipper רשאית להפסיק או להשעות את הגישה לשירות בכל עת, מכל סיבה שהיא,
            ללא הודעה מוקדמת וללא אחריות כלפי המשתמש.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. שיפוי</h2>
          <p>
            המשתמש מתחייב לשפות ולפצות את FB Zipper, מנהליה, עובדיה ושותפיה בגין כל נזק,
            הפסד, תביעה, הוצאה או עלות (כולל שכר טרחת עורכי דין) הנובעים משימושו בשירות
            או מהפרת תנאי שימוש אלה.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. דין וסמכות שיפוט</h2>
          <p>
            תנאי שימוש אלה כפופים לחוקי מדינת ישראל. כל מחלוקת הנובעת מתנאים אלה או
            מהשימוש בשירות תידון בבתי המשפט המוסמכים בתל אביב-יפו בלבד.
          </p>
        </section>

        <section className="terms-section">
          <h2>10. יצירת קשר</h2>
          <p>
            לשאלות בנוגע לתנאי שימוש אלה, ניתן לפנות אלינו בכתובת: support@fbzipper.com
          </p>
        </section>

        <div className="terms-acceptance">
          <p>
            <strong>בעצם השימוש בשירות, הנך מאשר כי קראת והבנת תנאים אלה ומסכים להם במלואם.</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export { TermsWrapper };
